export enum ResourceType {
    ProfileImage = 0,
    NodeVideo = 1,
    NodeImage = 2,
    NodeAudio = 3,
    LessonImage = 4,
    NodeInfoIcon = 5,
    Game = 6
}